import Vue from 'vue'
import VeeValidate from 'vee-validate'

const config = {
  locale: 'en',
  events: 'input',
  dictionary: {
    en: {
      messages: {
        required: (field) => field + ' should not be empty.',
        min: (field, args) => field + ' should be at least ' + args + ' alphanumeric characters.',
        max: (field, args) => field + ' should be less than ' + args + ' alphanumeric characters.',
        digits: (field, args) => field + ' should be ' + args + ' digit',
        min_value: (field, args) => field + ' should be at least ' + args,
        max_value: (field, args) => field + ' should be less than ' + args,
        integer: (field) => field + ' should be integer',
        mimes: (field, args) => field + ' should be mime ' + args,
        ext: (field, args) => field + ' should be extension ' + args,
        dimensions: (field, args) => field + ' should be ' + args,
        regex: (field) => 'The ' + field + ' is incorrect.',
        email: () => 'Please enter right email format.',
        confirmed: () => 'Password confirmation is incorrect.'
      },
      attributes: {
      }
    },
    ja: {
      messages: {
        required: (field) => field + ' は必須です。',
        min: (field, args) => field + ' は ' + args + ' 文字以上の英数字で入力してください。',
        max: (field, args) => field + ' は ' + args + ' 文字以下の英数字で入力してください。',
        digits: (field, args) => field + ' は ' + args + ' 桁の数字で入力してください。',
        min_value: (field, args) => field + ' は ' + args + ' 以上の値を入力してください。',
        max_value: (field, args) => field + ' は ' + args + ' 以下の値を入力してください。',
        integer: (field) => field + ' は整数で入力してください。',
        mimes: (field, args) => field + ' は ' + args + ' 形式のファイルを選択してください。',
        ext: (field, args) => field + ' は ' + args + ' 形式のファイルを選択してください。',
        dimensions: (field, args) => field + ' は ' + args + ' である必要があります。',
        regex: (field) => field + ' の形式が正しくありません。',
        email: () => 'メールアドレスを正しく入力してください。',
        confirmed: () => 'パスワードが一致しません。'
      },
      attributes: {
      }
    }
  }
}

Vue.use(VeeValidate, config)



// WEBPACK FOOTER //
// ./src/plugins/validation.js